<template>
  <div>
    <h6 style="margin: 0px !important">{{ BORCORT }}</h6>
    <p style="color: #ea5455; margin: 0px !important">{{ BORCGUN }}</p>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
import moment from "moment";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      BORCORT: "",
      BORCGUN: 0,
    };
  },
  methods: {
    gelenData() {
      this.BORCORT = this.parseDate(this.params.data.BORCORT);

      this.BORCGUN = this.params.data.BORCGUN;
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
